import { Container } from '@mui/material';
import KoriSearchForm from '@/components/KoriSearchForm';
import React, { useEffect, useState } from 'react';

import { fetchKoriList, fetchKoriListByKeyword, fetchKoriById } from '@/services/koriService';
import KoriList from '@/components/KoriList/KoriList';

const KoriHaku = () => {
  const [search, setSearch] = useState({ type: null, params: {} });
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);

  const fetchData = async (search) => {
    switch (search.type) {
      case 'date':
        return await fetchKoriList(search.params.beforeDate, search.params.lastId);
      case 'keyword':
        return await fetchKoriListByKeyword(search.params.keyword);
      case 'id':
      {
        const res = await fetchKoriById(search.params.id);
        return res ? [res] : [];
      }
      default:
        return [];
    }
  };

  const handleSearch = async (type, params) => {
    setData([]);
    setSearch({ type, params });
    setHasMore(true);
  };

  useEffect(() => {
    if (!search.type) return;

    const loadMore = async () => {
      if (loading || !hasMore) return;

      setLoading(true);
      try {
        const newData = await fetchData(search);
        setData(prev => [...prev, ...newData]);

        if (newData.length === 0) {
          setHasMore(false);
        }
      }
      catch (error) {
        setError(error);
        setHasMore(false);
      }

      setLoading(false);
    };

    loadMore();
  }, [search]);

  const handleLoadMore = () => {
    if (search.type === 'date') {
      setSearch(prev => ({
        ...prev,
        params: {
          ...prev.params,
          beforeDate: data[data.length - 1]?.vahvistuspvm,
          lastId: data[data.length - 1]?.id?.id,
        },
      }));
    }
  };

  return (
    <Container disableGutters>
      <KoriSearchForm onSearch={handleSearch} />
      <KoriList
        data={data}
        loading={loading}
        hasMore={hasMore}
        loadMore={handleLoadMore}
      />
    </Container>
  );
};

export default KoriHaku;
